<template>
	<main class="payment-result">
		<div class="payment-result__inner _cnt">
			<duv class="payment-result__title _md">
				{{
					$t(
						'Unfortunately, we were unable to process your payment. Please try again later'
					)
				}}
			</duv>
		</div>
	</main>
</template>

<script>
import { ButtonThemes } from '@/components/base/BaseButton.vue';

export default {
	name: 'PaymentFailPage',
	components: {},
	props: [],
	data: function () {
		return {
			ButtonThemes,
		};
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.payment-result {
	@include header-indent;
	@include adaptiveValue('padding-top', 60, 25);
	@include adaptiveValue('padding-bottom', 60, 25);
	position: relative;
	min-height: calc(100vh - 98px);
	@media (max-width: $md1) {
		min-height: calc(100vh - 70px);
	}
	@media (max-width: $md4) {
		min-height: calc(100vh - 50px);
	}
	display: flex;
	align-items: center;
	&::before {
		content: '';
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-image: url('@/assets/images/bg/vertical-bg.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-size: 100% 100%;
		z-index: -1;
	}
	&__inner {
	}

	&__title {
		display: block;
		text-align: center;
		span {
			color: var(--secondary-color);
		}
	}
}
</style>
